import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
    name: 'localeDate',
    standalone: false
})
@Injectable({ providedIn: "root" })
export class LocaleDatePipe implements PipeTransform {
	transform(value: any, locale: string, format: string): string {
		return formatDate(value, format, locale);
	}
}